import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessFolderStore = {
  state: {
    businessFolders: [],
    businessFolder: null
  },
  getters,
  mutations,
  actions
}

export default BusinessFolderStore